<template>
<svg data-svg-lvl-2="flyleaffront-block" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 514 430">
<PreviewLayersFlyleaffrontBlockShadowD :params="params" v-if="!params.isFlap7" />
<PreviewLayersFlyleaffrontBlockShadowD_F7 :params="params" v-if="params.isFlap7" />
<PreviewLayersFlyleaffrontBlockFlyleaffrontD :params="params" v-if="!params.isFlap7" />
<PreviewLayersFlyleaffrontBlockFlyleaffrontD_F7 :params="params" v-if="params.isFlap7" />
<PreviewLayersFlyleaffrontBlockContourD :params="params" v-if="!params.isFlap7" />
<PreviewLayersFlyleaffrontBlockContourD_F7 :params="params" v-if="params.isFlap7" />
<component :params="params" :is="`PreviewLayersFlyleaffrontBlockPlasticP${params.plastic.flyleaffrontBlockComponent}`" v-if="params.plastic.flyleaffrontBlockComponent" />
<PreviewLayersFlyleaffrontBlockPocketR :params="params" v-if="params.flyleaffrontPocket" />
<PreviewDraggableInner :params="params" />
</svg></template>


<script>
/** Этот компонент генерируется автоматически, руками ничего менять нельзя!!! */
  
export default { components: {
      PreviewDraggableInner: () => import('/src/components/preview/DraggableInner'),
     },props: { params: { type: Object, required: true, }, }, data() { return {} },}
</script>